import { CommonModule, Location } from "@angular/common";
import { afterNextRender, Component, computed, inject, signal } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { ReceiptService } from "@malirang/api-client";
import { AlertService, Icon } from "@malirang/front-share";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { ContainerComponent } from "../../../components/container/container.component";
import { SubscribeStore } from "../../../stores/subscribe.store";

type Segment = "center-stat" | "accounting" | "hrm";

@Component({
    selector: "app-administration",
    templateUrl: "./administration.layout.html",
    styleUrls: ["./administration.layout.css"],
    imports: [CommonModule, ContainerComponent, RouterOutlet, Icon, RouterLink],
})
export class AdministrationLayout {
    readonly receiptService = inject(ReceiptService);
    readonly router = inject(Router);
    readonly navigationEnd$ = injectNavigationEnd();
    readonly subscribeStore = inject(SubscribeStore);
    readonly alertService = inject(AlertService);
    readonly location = inject(Location);

    segment = signal<Segment>("center-stat");
    isFreePlan = computed(() => this.subscribeStore.subscribe()?.plan === "FREE");

    constructor() {
        afterNextRender(() => {
            this.handleGuard();
            this.setSegment();
            this.navigationEnd$.subscribe({
                next: () => {
                    this.handleGuard();
                    this.setSegment();
                },
            });
        });
    }

    handleGuard() {
        if (this.isFreePlan()) {
            if (this.isFreePlan()) {
                this.alertService
                    .open({
                        title: "플랜 구독 후 이용 가능합니다.",
                        type: "info",
                        content: `해당 메뉴는 플랜 구독 후 이용 가능합니다.
                        구독을 원하시면 구독 페이지로 이동해주세요`,
                        buttons: {
                            cancel: {
                                text: "닫기",
                            },
                            confirm: {
                                text: "플랜 조회",
                            },
                        },
                    })
                    .closed.subscribe({
                        next: (res) => {
                            if (res?.action === "confirm") {
                                this.router.navigate(["/subscription"]);
                            } else {
                                this.location.back();
                            }
                        },
                    });
                return;
            }
        }
    }

    setSegment() {
        const url = this.router.url;

        if (url.includes("/administration/center-stat")) {
            this.segment.set("center-stat");
            return;
        } else if (url.includes("/administration/accounting")) {
            this.segment.set("accounting");
            return;
        } else if (url.includes("/administration/hrm")) {
            this.segment.set("hrm");
            return;
        }
    }
}
